import React from "react";
import { Link } from "react-router-dom";
import Can from "../../../../hoc/FullControllHoc/can";
import { useReadOnly } from "../../../../utils/useReadOnly";

let isSelectedFolderCase = "case";
const EmptyMessage = ({ mainMessage, subMessage, selectedFolderType }) => {
  const isCustomRole = useReadOnly();
  return (
    <div className="empty-message-container">
      <div className="empty-message-chid">
        <div className="empty-message-chid-2">
          <div className="empty-message-chid-3" />
          <div className="empty-title">
            <div className="empty-main-message">
              {selectedFolderType === isSelectedFolderCase && !isCustomRole ? (
                <Can
                  task={"create-case"}
                  taskContainer="slidebox"
                  edit={() => (
                    <Link id="uploadImagesLinkTag" to="/slidebox/upload">
                      {mainMessage}
                    </Link>
                  )}
                  noAccess={() => mainMessage}
                />
              ) : (
                mainMessage
              )}
            </div>
            <div className="empty-sub-message">{subMessage}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyMessage;
